/**
 * 考试模块API
 */
import http from './http'

class ExamApi {
    // 获取题目分类
    static getClassify() {
        return http.httpGet('exam/classify');
    }

    // 获取题目列表
    static getList() {
        return http.httpGet('exam/list');
    }

    // 获取考试第一名信息
    static getFirstRank() {
        return http.httpGet('exam/firstRank');
    }

    // 提交考试信息
    static submitExam(data) {
        return http.httpPost('exam/submitAnswer', data);
    }

    // 取消考试
    static cancelExam(data) {
        return http.httpPost('exam/cancel', data);
    }

    // 获取当前用户最新考试成绩
    static getNewestItem() {
        return http.httpGet('exam');
    }

    // 获取考试排名
    static getRankingList() {
        return http.httpGet('exam/rankingList');
    }

    // 点赞
    static like(id) {
        return http.httpPost('exam/like', {id});
    }

    // 获取成员平均能力统计数据
    static getMeanPower() {
        return http.httpGet('exam/power');
    }

    // 获取个人面试官战绩统计数据
    static getExamLevel() {
        return http.httpGet('exam/level');
    }
}

export default ExamApi;



// WEBPACK FOOTER //
// ./app/api/exam.api.js